<template>
<div class="">
    <div class="md:w-9/12 md:m-auto py-16 flex items-center justify-center">
    <div class="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg pb-8">
        <div class="text-center pt-8">
        <h1 class="text-9xl font-bold text-gray-400 dark:text-gray-100">{{ error404.title }}</h1>
        <h1 class="text-3xl md:text-6xl font-medium py-8 dark:text-gray-300">{{ error404.subtitle }}</h1>
        <p class="text-1xl md:text-2xl pb-8 px-12 font-medium dark:text-gray-400">{{ error404.description }}</p>
        <button @click="$router.push('/')"
        class="bg-gradient-to-r from-green-400 to-green-500 hover:from-green-300 hover:to-green-400 text-white font-semibold px-6 py-3 rounded-md mr-6">
        {{ buttons.index }}
        </button>
        <button @click="$store.commit('showContact')"
        class="bg-gradient-to-r from-gray-400 to-gray-500 hover:from-gray-300 hover:to-gray-400 text-white font-semibold px-6 py-3 rounded-md">
        {{ buttons.contactMe }}
        </button>
        </div>
    </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Error404',
    computed: {
        error404() {
            return this.$store.getters.GetError['404']
        },
        buttons() {
            return this.$store.getters.GetButtons
        }
    }
}
</script>

<style>

</style>